import { useAuth } from '@shared/auth';
import { useTranslation } from '@shared/localization';

import { PageLayout } from '@/components/common';
import { AlertWarning } from '@/components/common/alerts';

export function ForbidenError() {
  const { t } = useTranslation();
  const { userId, givenName } = useAuth();

  return (
    <PageLayout>
      <AlertWarning title={t('Wrong Account!')}>
        {t(
          'It looks like you are currently logged in as {{user}} but this page is intended for someone else. Please try again with the correct account.',
          {
            user: givenName ?? userId,
          },
        )}
      </AlertWarning>
    </PageLayout>
  );
}
